import { Header4 } from '@cian/ui-kit';

import * as React from 'react';
import classNames from 'classnames';

import * as styles from './styles.css';

interface IVerificationStep {
  index: number;
  children: React.ReactNode;
  className?: string;
  isMobile?: boolean;
}

export const VerificationStep: React.FC<IVerificationStep> = ({ index, children, className, isMobile }) => (
  <div className={classNames(styles['root'], { [styles['mobile']]: isMobile }, className)}>
    <div className={styles['index']}>
      <Header4 color="black_40">{index}</Header4>
    </div>
    <div className={styles['text']}>{children}</div>
  </div>
);

VerificationStep.displayName = 'VerificationStep';
